// 物件コピーモーダル
const ModalPropertyCopy = {
  namespaced: true,

  state: {
    modal: false,
    property: {},
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getProperty: state => {
      return state.property
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setProperty(state, property) {
      state.property = property
    },
  },
  actions: {
    set({ commit }, item) {
      commit('setProperty', item.property)
      commit('setModal', true)
    },
    reset({ commit }) {
      commit('setModal', false)
      commit('setProperty', {})
    },
  },
}

export default ModalPropertyCopy
